module.exports = __webpack_public_path__ + "static/media/edit-living.6c095a38.svg";